export class Company {
    idAdmEmpresa : number;
    idAdmGrupoEconomico : number;
    idAdmCiudad : number;
    idAdmMoneda : number;
    codigo : string;
    nombre : string;
    nit : string;
    telefono : string;
    direccion : string;
    emailRepresentante : string;
    vip : boolean;
}
